import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';

// ── Yardımcı ────────────────────────────────────────────────
const paraFormat = (tutar) => {
  if (tutar === null || tutar === undefined || tutar === '') return '—';
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(tutar)) + ' ₺';
};

const bugun = () => new Date().toISOString().split('T')[0];

const tarihFormat = (t) =>
  t ? new Date(t).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

const durumRenk = (durum) => {
  switch (durum) {
    case 'Tamamlandı':   return { bg: '#EAF3DE', renk: '#3B6D11' };
    case 'Kısmi Ödendi': return { bg: '#FEF3C7', renk: '#854F0B' };
    case 'Gecikmiş':     return { bg: '#FEE2E2', renk: '#DC2626' };
    case 'Bekliyor':     return { bg: '#FEE2E2', renk: '#DC2626' };
    default:             return { bg: '#F3F4F6', renk: '#6B7280' };
  }
};

const hesaplaDurum = (odenen, toplam) => {
  const o = parseFloat(odenen) || 0;
  const t = parseFloat(toplam) || 0;
  if (t > 0 && o >= t) return 'Tamamlandı';
  if (o > 0) return 'Kısmi Ödendi';
  return 'Bekliyor';
};

const BOSH_ODEME = {
  musteri_id: '', sefer_id: '', aciklama: '',
  toplam_tutar: '', odenen_tutar: '0', vade_tarihi: '', odeme_yontemi: 'Havale', notlar: ''
};

// ── Modal kapsayıcı (ortalanmış, masaüstü + mobil uyumlu) ───
function ModalKapsayici({ children, onKapat, zIndex = 200 }) {
  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onKapat(); }}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex, padding: '16px',
      }}>
      <div style={{
        background: '#fff', borderRadius: '16px',
        width: '100%', maxWidth: '520px',
        maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      }}>
        {children}
      </div>
    </div>
  );
}

// ── Header ───────────────────────────────────────────────────
function Header({ kullanici, onCikis }) {
  return (
    <div style={{
      background: '#0D3B7A', color: '#fff',
      padding: '0 16px', height: '56px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      position: 'sticky', top: 0, zIndex: 100,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: '800', letterSpacing: '1px', lineHeight: 1 }}>BYR</div>
          <div style={{ fontSize: '9px', color: '#93C5FD', letterSpacing: '2px', lineHeight: 1 }}>SWORD LOJİSTİK</div>
        </div>
        <div style={{ borderLeft: '1px solid rgba(255,255,255,0.2)', paddingLeft: '12px', fontSize: '14px', fontWeight: '600' }}>
          💳 Ödeme Takibi
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '13px', fontWeight: '600' }}>{kullanici?.ad || 'Muhasebeci'}</div>
          <div style={{ fontSize: '10px', color: '#93C5FD' }}>Muhasebeci</div>
        </div>
        <button onClick={onCikis}
          style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
          Çıkış
        </button>
      </div>
    </div>
  );
}

// ── Ana Panel ────────────────────────────────────────────────
function MuhasebeciPanel({ onCikis }) {
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');

  const [odemeler, setOdemeler]     = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [seferler, setSeferler]     = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [aktifSekme, setAktifSekme] = useState('bekleyen');

  // Modal state'leri
  const [yeniOdemeModal, setYeniOdemeModal]   = useState(false);
  const [odemeAlModal, setOdemeAlModal]       = useState(null);
  const [detayModal, setDetayModal]           = useState(null);
  const [duzenleModal, setDuzenleModal]       = useState(null); // ödeme düzenle
  const [hareketler, setHareketler]           = useState([]);
  const [hareketDuzenle, setHareketDuzenle]   = useState(null);

  // Form state'leri
  const [yeniOdeme, setYeniOdeme]           = useState(BOSH_ODEME);
  const [odemeAlForm, setOdemeAlForm]       = useState({ tutar: '', tarih: bugun(), aciklama: '' });
  const [kayitYapiliyor, setKayitYapiliyor] = useState(false);

  const odemeleriGetir = useCallback(async () => {
    setYukleniyor(true);
    try {
      await supabase
        .from('odemeler')
        .update({ odeme_durumu: 'Gecikmiş' })
        .lt('vade_tarihi', bugun())
        .in('odeme_durumu', ['Bekliyor', 'Kısmi Ödendi']);

      const { data } = await supabase
        .from('odemeler')
        .select('*, musteriler(ad), seferler(sefer_no)')
        .order('created_at', { ascending: false });

      setOdemeler(data || []);
    } catch (e) { console.error(e); }
    setYukleniyor(false);
  }, []);

  useEffect(() => {
    odemeleriGetir();
    supabase.from('musteriler').select('id, ad').order('ad').then(({ data }) => data && setMusteriler(data));
    supabase.from('seferler').select('id, sefer_no').order('created_at', { ascending: false }).then(({ data }) => data && setSeferler(data));
  }, [odemeleriGetir]);

  // ── Yeni ödeme ──────────────────────────────────────────────
  const yeniOdemeEkle = async () => {
    if (!yeniOdeme.musteri_id) return alert('Müşteri seçiniz!');
    const toplam = parseFloat(yeniOdeme.toplam_tutar);
    if (!toplam || toplam <= 0) return alert('Geçerli bir tutar giriniz!');
    const odenen = parseFloat(yeniOdeme.odenen_tutar) || 0;
    setKayitYapiliyor(true);
    const { error } = await supabase.from('odemeler').insert([{
      musteri_id:    yeniOdeme.musteri_id,
      sefer_id:      yeniOdeme.sefer_id || null,
      aciklama:      yeniOdeme.aciklama,
      toplam_tutar:  toplam,
      odenen_tutar:  odenen,
      vade_tarihi:   yeniOdeme.vade_tarihi || null,
      odeme_yontemi: yeniOdeme.odeme_yontemi,
      odeme_durumu:  hesaplaDurum(odenen, toplam),
      notlar:        yeniOdeme.notlar,
    }]);
    if (error) { alert('Kayıt hatası: ' + error.message); }
    else { setYeniOdemeModal(false); setYeniOdeme(BOSH_ODEME); odemeleriGetir(); }
    setKayitYapiliyor(false);
  };

  // ── Ödeme düzenle ────────────────────────────────────────────
  const odemeGuncelle = async () => {
    if (!duzenleModal.aciklama && !duzenleModal.toplam_tutar) return alert('En az bir alan doldurunuz!');
    setKayitYapiliyor(true);
    const { error } = await supabase.from('odemeler').update({
      aciklama:      duzenleModal.aciklama,
      toplam_tutar:  parseFloat(duzenleModal.toplam_tutar),
      vade_tarihi:   duzenleModal.vade_tarihi || null,
      odeme_yontemi: duzenleModal.odeme_yontemi,
      notlar:        duzenleModal.notlar,
    }).eq('id', duzenleModal.id);
    if (error) { alert('Güncelleme hatası: ' + error.message); }
    else { setDuzenleModal(null); odemeleriGetir(); }
    setKayitYapiliyor(false);
  };

  // ── Ödeme sil ────────────────────────────────────────────────
  const odemeSil = async (odeme) => {
    if (!window.confirm(`"${odeme.musteriler?.ad}" için ${paraFormat(odeme.toplam_tutar)} tutarlı ödeme kaydını silmek istediğinize emin misiniz?`)) return;
    setKayitYapiliyor(true);
    // Önce hareketleri sil
    await supabase.from('odeme_hareketleri').delete().eq('odeme_id', odeme.id);
    const { error } = await supabase.from('odemeler').delete().eq('id', odeme.id);
    if (error) { alert('Silme hatası: ' + error.message); }
    else { odemeleriGetir(); }
    setKayitYapiliyor(false);
  };

  // ── Ödeme al ────────────────────────────────────────────────
  const odemeAl = async () => {
    const tutar = parseFloat(odemeAlForm.tutar);
    if (!tutar || tutar <= 0) return alert('Geçerli bir tutar giriniz!');
    setKayitYapiliyor(true);
    const odeme = odemeAlModal;
    const yeniOdenen = (odeme.odenen_tutar || 0) + tutar;
    const yeniDurum  = yeniOdenen >= odeme.toplam_tutar ? 'Tamamlandı' : yeniOdenen > 0 ? 'Kısmi Ödendi' : odeme.odeme_durumu;
    const { error: hrErr } = await supabase.from('odeme_hareketleri').insert([{
      odeme_id: odeme.id, tutar, tarih: odemeAlForm.tarih, aciklama: odemeAlForm.aciklama,
    }]);
    if (hrErr) { alert('Hareket kaydı hatası: ' + hrErr.message); setKayitYapiliyor(false); return; }
    await supabase.from('odemeler').update({ odenen_tutar: yeniOdenen, odeme_durumu: yeniDurum }).eq('id', odeme.id);
    setOdemeAlModal(null);
    setOdemeAlForm({ tutar: '', tarih: bugun(), aciklama: '' });
    odemeleriGetir();
    setKayitYapiliyor(false);
  };

  // ── Hareket işlemleri ────────────────────────────────────────
  const odenenTutarYenile = async (odemeId, toplamTutar) => {
    const { data } = await supabase.from('odeme_hareketleri').select('tutar').eq('odeme_id', odemeId);
    const yeniOdenen = (data || []).reduce((t, h) => t + (h.tutar || 0), 0);
    const yeniDurum  = yeniOdenen >= toplamTutar ? 'Tamamlandı' : yeniOdenen > 0 ? 'Kısmi Ödendi' : 'Bekliyor';
    await supabase.from('odemeler').update({ odenen_tutar: yeniOdenen, odeme_durumu: yeniDurum }).eq('id', odemeId);
  };

  const hareketleriYenile = async (odemeId) => {
    const { data } = await supabase.from('odeme_hareketleri').select('*').eq('odeme_id', odemeId).order('tarih', { ascending: false });
    setHareketler(data || []);
  };

  const hareketSil = async (h) => {
    if (!window.confirm(`${paraFormat(h.tutar)} tutarlı tahsilatı silmek istediğinize emin misiniz?`)) return;
    setKayitYapiliyor(true);
    await supabase.from('odeme_hareketleri').delete().eq('id', h.id);
    await odenenTutarYenile(detayModal.id, detayModal.toplam_tutar);
    await hareketleriYenile(detayModal.id);
    odemeleriGetir();
    setKayitYapiliyor(false);
  };

  const hareketGuncelle = async () => {
    const tutar = parseFloat(hareketDuzenle.tutar);
    if (!tutar || tutar <= 0) return alert('Geçerli bir tutar giriniz!');
    setKayitYapiliyor(true);
    await supabase.from('odeme_hareketleri').update({ tutar, tarih: hareketDuzenle.tarih, aciklama: hareketDuzenle.aciklama }).eq('id', hareketDuzenle.id);
    await odenenTutarYenile(detayModal.id, detayModal.toplam_tutar);
    await hareketleriYenile(detayModal.id);
    setHareketDuzenle(null);
    odemeleriGetir();
    setKayitYapiliyor(false);
  };

  const detayAc = async (odeme) => {
    setDetayModal(odeme);
    setHareketler([]);
    const { data } = await supabase.from('odeme_hareketleri').select('*').eq('odeme_id', odeme.id).order('tarih', { ascending: false });
    setHareketler(data || []);
  };

  // ── Metrikler ────────────────────────────────────────────────
  const simdi  = new Date();
  const buAy   = `${simdi.getFullYear()}-${String(simdi.getMonth() + 1).padStart(2, '0')}`;
  const toplamAlacak   = odemeler.filter(o => o.odeme_durumu !== 'Tamamlandı').reduce((t, o) => t + (o.toplam_tutar - (o.odenen_tutar || 0)), 0);
  const buAyBeklenen   = odemeler.filter(o => o.vade_tarihi?.startsWith(buAy) && o.odeme_durumu !== 'Tamamlandı').reduce((t, o) => t + (o.toplam_tutar - (o.odenen_tutar || 0)), 0);
  const gecikmisToplam = odemeler.filter(o => o.odeme_durumu === 'Gecikmiş').reduce((t, o) => t + (o.toplam_tutar - (o.odenen_tutar || 0)), 0);
  const buAyTahsil     = odemeler.filter(o => o.odeme_durumu === 'Tamamlandı' && o.created_at?.startsWith(buAy)).reduce((t, o) => t + (o.odenen_tutar || 0), 0);

  const bekleyenler   = odemeler.filter(o => o.odeme_durumu !== 'Tamamlandı');
  const tamamlananlar = odemeler.filter(o => o.odeme_durumu === 'Tamamlandı');
  const gosterilen    = aktifSekme === 'bekleyen' ? bekleyenler : tamamlananlar;

  return (
    <div style={{ minHeight: '100vh', background: '#F1F5F9', fontFamily: 'Arial, sans-serif' }}>
      <Header kullanici={kullanici} onCikis={onCikis} />

      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '20px 16px' }}>

        {/* Metrik Kartları */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px' }}>
          {[
            { label: 'Toplam Alacak',  value: paraFormat(toplamAlacak),   renk: '#185FA5', ikon: '📊' },
            { label: 'Bu Ay Beklenen', value: paraFormat(buAyBeklenen),   renk: '#854F0B', ikon: '📅' },
            { label: 'Gecikmiş',       value: paraFormat(gecikmisToplam), renk: '#DC2626', ikon: '⚠️' },
            { label: 'Bu Ay Tahsil',   value: paraFormat(buAyTahsil),     renk: '#3B6D11', ikon: '✅' },
          ].map((m, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: '12px', padding: '14px 16px', border: '1px solid #E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
              <div style={{ fontSize: '18px', marginBottom: '4px' }}>{m.ikon}</div>
              <div style={{ fontSize: '18px', fontWeight: '800', color: m.renk, lineHeight: 1.2 }}>{yukleniyor ? '...' : m.value}</div>
              <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>{m.label}</div>
            </div>
          ))}
        </div>

        {/* Sekme + Yeni butonu */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', gap: '10px' }}>
          <div style={{ display: 'flex', gap: '6px' }}>
            {[
              { key: 'bekleyen',   label: 'Bekleyen',   count: bekleyenler.length },
              { key: 'tamamlanan', label: 'Tamamlanan', count: tamamlananlar.length },
            ].map(s => (
              <button key={s.key} onClick={() => setAktifSekme(s.key)}
                style={{ padding: '8px 14px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: aktifSekme === s.key ? '700' : '400', background: aktifSekme === s.key ? '#0D3B7A' : '#E2E8F0', color: aktifSekme === s.key ? '#fff' : '#555' }}>
                {s.label} <span style={{ opacity: 0.8, fontSize: '11px' }}>({s.count})</span>
              </button>
            ))}
          </div>
          <button onClick={() => setYeniOdemeModal(true)}
            style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '700', whiteSpace: 'nowrap' }}>
            + Yeni
          </button>
        </div>

        {/* Ödeme Kartları */}
        {yukleniyor ? (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '48px', textAlign: 'center', color: '#9CA3AF' }}>Yükleniyor...</div>
        ) : gosterilen.length === 0 ? (
          <div style={{ background: '#fff', borderRadius: '14px', border: '1px dashed #CBD5E1', padding: '48px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: '36px', marginBottom: '10px' }}>💳</div>
            <div style={{ fontSize: '15px', fontWeight: '600', color: '#64748B' }}>
              {aktifSekme === 'bekleyen' ? 'Bekleyen ödeme yok' : 'Tamamlanan ödeme yok'}
            </div>
          </div>
        ) : (
          gosterilen.map(row => {
            const kalanHesap = row.toplam_tutar - (row.odenen_tutar || 0);
            const { bg, renk } = durumRenk(row.odeme_durumu);
            return (
              <div key={row.id} style={{ background: '#fff', borderRadius: '14px', padding: '16px', marginBottom: '10px', border: '1px solid #E2E8F0', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>

                {/* Üst: müşteri + durum */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                  <div>
                    <div style={{ fontWeight: '700', fontSize: '15px', color: '#0D3B7A' }}>{row.musteriler?.ad || '—'}</div>
                    {row.aciklama && <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>{row.aciklama}</div>}
                    {row.seferler?.sefer_no && <div style={{ fontSize: '11px', color: '#60A5FA', marginTop: '2px' }}>🚛 {row.seferler.sefer_no}</div>}
                  </div>
                  <span style={{ background: bg, color: renk, padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', whiteSpace: 'nowrap', marginLeft: '8px' }}>
                    {row.odeme_durumu}
                  </span>
                </div>

                {/* Tutarlar */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '12px' }}>
                  <div style={{ textAlign: 'center', background: '#F8FAFC', borderRadius: '8px', padding: '8px 4px' }}>
                    <div style={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '2px' }}>Toplam</div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: '#374151' }}>{paraFormat(row.toplam_tutar)}</div>
                  </div>
                  <div style={{ textAlign: 'center', background: '#F0FDF4', borderRadius: '8px', padding: '8px 4px' }}>
                    <div style={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '2px' }}>Ödenen</div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: '#3B6D11' }}>{paraFormat(row.odenen_tutar || 0)}</div>
                  </div>
                  <div style={{ textAlign: 'center', background: kalanHesap > 0 ? '#FFF1F2' : '#F0FDF4', borderRadius: '8px', padding: '8px 4px' }}>
                    <div style={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '2px' }}>Kalan</div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: kalanHesap > 0 ? '#DC2626' : '#3B6D11' }}>{paraFormat(kalanHesap)}</div>
                  </div>
                </div>

                {/* Alt: vade + butonlar */}
                <div style={{ borderTop: '1px solid #F1F5F9', paddingTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                  <div style={{ fontSize: '11px', color: '#9CA3AF' }}>
                    {row.vade_tarihi && `📅 ${tarihFormat(row.vade_tarihi)}`}
                    {row.odeme_yontemi && ` · ${row.odeme_yontemi}`}
                  </div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    {row.odeme_durumu !== 'Tamamlandı' && (
                      <button onClick={() => { setOdemeAlModal(row); setOdemeAlForm({ tutar: '', tarih: bugun(), aciklama: '' }); }}
                        style={{ background: '#3B6D11', color: '#fff', border: 'none', padding: '7px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: '700' }}>
                        💰 Al
                      </button>
                    )}
                    <button onClick={() => detayAc(row)}
                      style={{ background: '#EFF6FF', color: '#0D3B7A', border: '1px solid #BFDBFE', padding: '7px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>
                      Detay
                    </button>
                    <button onClick={() => setDuzenleModal({ ...row })}
                      style={{ background: '#F8FAFC', color: '#374151', border: '1px solid #E2E8F0', padding: '7px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>
                      ✏️
                    </button>
                    <button onClick={() => odemeSil(row)}
                      style={{ background: '#FFF1F2', color: '#DC2626', border: '1px solid #FECACA', padding: '7px 12px', borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>
                      🗑️
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* ── Yeni Ödeme Modal ── */}
      {yeniOdemeModal && (
        <ModalKapsayici onKapat={() => setYeniOdemeModal(false)}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>Yeni Ödeme Kaydı</div>
              <button onClick={() => setYeniOdemeModal(false)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <FormAlan label="Müşteri *">
                <select value={yeniOdeme.musteri_id} onChange={e => setYeniOdeme({ ...yeniOdeme, musteri_id: e.target.value })} style={selectStil}>
                  <option value="">— Müşteri seçin —</option>
                  {musteriler.map(m => <option key={m.id} value={m.id}>{m.ad}</option>)}
                </select>
              </FormAlan>
              <FormAlan label="Sefer (isteğe bağlı)">
                <select value={yeniOdeme.sefer_id} onChange={e => setYeniOdeme({ ...yeniOdeme, sefer_id: e.target.value })} style={selectStil}>
                  <option value="">— Sefer seçin —</option>
                  {seferler.map(s => <option key={s.id} value={s.id}>{s.sefer_no}</option>)}
                </select>
              </FormAlan>
              <FormAlan label="Açıklama">
                <input value={yeniOdeme.aciklama} onChange={e => setYeniOdeme({ ...yeniOdeme, aciklama: e.target.value })} placeholder="Kargo ücreti, depolama vb." style={inputStil} />
              </FormAlan>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <FormAlan label="Toplam Tutar (₺) *">
                  <input type="number" value={yeniOdeme.toplam_tutar} onChange={e => setYeniOdeme({ ...yeniOdeme, toplam_tutar: e.target.value })} placeholder="0.00" style={inputStil} />
                </FormAlan>
                <FormAlan label="Ödenen Tutar (₺)">
                  <input type="number" value={yeniOdeme.odenen_tutar} onChange={e => setYeniOdeme({ ...yeniOdeme, odenen_tutar: e.target.value })} placeholder="0.00" style={inputStil} />
                </FormAlan>
                <FormAlan label="Kalan Tutar (₺) — otomatik">
                  <input readOnly
                    value={yeniOdeme.toplam_tutar ? ((parseFloat(yeniOdeme.toplam_tutar) || 0) - (parseFloat(yeniOdeme.odenen_tutar) || 0)).toFixed(2) : ''}
                    style={{ ...inputStil, background: '#f5f7fa', fontWeight: '700', color: ((parseFloat(yeniOdeme.toplam_tutar)||0)-(parseFloat(yeniOdeme.odenen_tutar)||0)) > 0 ? '#DC2626' : '#3B6D11' }} />
                </FormAlan>
                <FormAlan label="Durum — otomatik">
                  <div style={{ ...inputStil, background: '#f5f7fa', display: 'flex', alignItems: 'center' }}>
                    {(() => { const d = hesaplaDurum(yeniOdeme.odenen_tutar, yeniOdeme.toplam_tutar); const { bg, renk } = durumRenk(d); return <span style={{ background: bg, color: renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>{d}</span>; })()}
                  </div>
                </FormAlan>
                <FormAlan label="Vade Tarihi">
                  <input type="date" value={yeniOdeme.vade_tarihi} onChange={e => setYeniOdeme({ ...yeniOdeme, vade_tarihi: e.target.value })} style={inputStil} />
                </FormAlan>
                <FormAlan label="Ödeme Yöntemi">
                  <select value={yeniOdeme.odeme_yontemi} onChange={e => setYeniOdeme({ ...yeniOdeme, odeme_yontemi: e.target.value })} style={selectStil}>
                    <option>Havale</option><option>EFT</option><option>Nakit</option><option>Çek</option>
                  </select>
                </FormAlan>
                <FormAlan label="Notlar">
                  <input value={yeniOdeme.notlar} onChange={e => setYeniOdeme({ ...yeniOdeme, notlar: e.target.value })} placeholder="Ek bilgi..." style={inputStil} />
                </FormAlan>
              </div>
            </div>
            <BtnPrimary onClick={yeniOdemeEkle} disabled={kayitYapiliyor}>{kayitYapiliyor ? 'Kaydediliyor...' : 'Kaydet'}</BtnPrimary>
          </div>
        </ModalKapsayici>
      )}

      {/* ── Ödeme Düzenle Modal ── */}
      {duzenleModal && (
        <ModalKapsayici onKapat={() => setDuzenleModal(null)}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>Ödeme Düzenle</div>
              <button onClick={() => setDuzenleModal(null)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '16px' }}>
              <strong style={{ color: '#0D3B7A' }}>{duzenleModal.musteriler?.ad}</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <FormAlan label="Açıklama">
                <input value={duzenleModal.aciklama || ''} onChange={e => setDuzenleModal({ ...duzenleModal, aciklama: e.target.value })} placeholder="Kargo ücreti, depolama vb." style={inputStil} />
              </FormAlan>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <FormAlan label="Toplam Tutar (₺) *">
                  <input type="number" value={duzenleModal.toplam_tutar} onChange={e => setDuzenleModal({ ...duzenleModal, toplam_tutar: e.target.value })} style={inputStil} />
                </FormAlan>
                <FormAlan label="Vade Tarihi">
                  <input type="date" value={duzenleModal.vade_tarihi || ''} onChange={e => setDuzenleModal({ ...duzenleModal, vade_tarihi: e.target.value })} style={inputStil} />
                </FormAlan>
                <FormAlan label="Ödeme Yöntemi">
                  <select value={duzenleModal.odeme_yontemi || 'Havale'} onChange={e => setDuzenleModal({ ...duzenleModal, odeme_yontemi: e.target.value })} style={selectStil}>
                    <option>Havale</option><option>EFT</option><option>Nakit</option><option>Çek</option>
                  </select>
                </FormAlan>
                <FormAlan label="Notlar">
                  <input value={duzenleModal.notlar || ''} onChange={e => setDuzenleModal({ ...duzenleModal, notlar: e.target.value })} placeholder="Ek bilgi..." style={inputStil} />
                </FormAlan>
              </div>
            </div>
            <BtnPrimary onClick={odemeGuncelle} disabled={kayitYapiliyor}>{kayitYapiliyor ? 'Kaydediliyor...' : 'Güncelle'}</BtnPrimary>
          </div>
        </ModalKapsayici>
      )}

      {/* ── Ödeme Al Modal ── */}
      {odemeAlModal && (
        <ModalKapsayici onKapat={() => setOdemeAlModal(null)}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>💰 Ödeme Al</div>
              <button onClick={() => setOdemeAlModal(null)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>
              <strong style={{ color: '#0D3B7A' }}>{odemeAlModal.musteriler?.ad}</strong>
              {' '}· Kalan: <strong style={{ color: '#DC2626' }}>{paraFormat(odemeAlModal.toplam_tutar - (odemeAlModal.odenen_tutar || 0))}</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <FormAlan label="Tahsil Edilen Tutar (₺) *">
                <input type="number" value={odemeAlForm.tutar} onChange={e => setOdemeAlForm({ ...odemeAlForm, tutar: e.target.value })}
                  placeholder="0.00" autoFocus
                  style={{ ...inputStil, fontSize: '22px', fontWeight: '800', color: '#0D3B7A', border: '2px solid #0D3B7A', padding: '12px' }} />
              </FormAlan>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <FormAlan label="Tarih">
                  <input type="date" value={odemeAlForm.tarih} onChange={e => setOdemeAlForm({ ...odemeAlForm, tarih: e.target.value })} style={inputStil} />
                </FormAlan>
                <FormAlan label="Açıklama">
                  <input value={odemeAlForm.aciklama} onChange={e => setOdemeAlForm({ ...odemeAlForm, aciklama: e.target.value })} placeholder="Havale açıklaması" style={inputStil} />
                </FormAlan>
              </div>
            </div>
            <BtnPrimary onClick={odemeAl} disabled={kayitYapiliyor} renk="#3B6D11">
              {kayitYapiliyor ? 'Kaydediliyor...' : '💰 Tahsil Et'}
            </BtnPrimary>
          </div>
        </ModalKapsayici>
      )}

      {/* ── Detay Modal ── */}
      {detayModal && (
        <ModalKapsayici onKapat={() => setDetayModal(null)}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>Ödeme Detayı</div>
              <button onClick={() => setDetayModal(null)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ background: '#F8FAFC', borderRadius: '12px', padding: '14px', marginBottom: '16px', border: '1px solid #E2E8F0' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                {[
                  { label: 'Müşteri', value: detayModal.musteriler?.ad },
                  { label: 'Sefer', value: detayModal.seferler?.sefer_no || '—' },
                  { label: 'Toplam', value: paraFormat(detayModal.toplam_tutar) },
                  { label: 'Ödenen', value: paraFormat(detayModal.odenen_tutar || 0) },
                  { label: 'Kalan', value: paraFormat(detayModal.toplam_tutar - (detayModal.odenen_tutar || 0)) },
                  { label: 'Vade', value: tarihFormat(detayModal.vade_tarihi) },
                  { label: 'Yöntem', value: detayModal.odeme_yontemi },
                  { label: 'Durum', value: detayModal.odeme_durumu },
                ].map((item, i) => (
                  <div key={i}>
                    <div style={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '2px' }}>{item.label}</div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a' }}>{item.value}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ fontSize: '13px', fontWeight: '700', marginBottom: '10px', color: '#374151' }}>
              Tahsilat Hareketleri ({hareketler.length})
            </div>
            {hareketler.length === 0 ? (
              <div style={{ color: '#9CA3AF', fontSize: '13px', textAlign: 'center', padding: '20px 0' }}>Henüz ödeme hareketi yok.</div>
            ) : (
              hareketler.map(h => (
                <div key={h.id} style={{ background: '#F0FDF4', borderRadius: '10px', padding: '12px 14px', marginBottom: '8px', border: '1px solid #BBF7D0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '800', color: '#3B6D11' }}>{paraFormat(h.tutar)}</div>
                    <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>
                      {tarihFormat(h.tarih)}{h.aciklama ? ` · ${h.aciklama}` : ''}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => setHareketDuzenle({ id: h.id, tutar: h.tutar, tarih: h.tarih || bugun(), aciklama: h.aciklama || '' })}
                      style={{ background: '#EFF6FF', color: '#0D3B7A', border: '1px solid #BFDBFE', padding: '5px 10px', borderRadius: '7px', fontSize: '12px', cursor: 'pointer' }}>✏️</button>
                    <button onClick={() => hareketSil(h)}
                      style={{ background: '#FFF1F2', color: '#DC2626', border: '1px solid #FECACA', padding: '5px 10px', borderRadius: '7px', fontSize: '12px', cursor: 'pointer' }}>🗑️</button>
                  </div>
                </div>
              ))
            )}
          </div>
        </ModalKapsayici>
      )}

      {/* ── Hareket Düzenle Modal ── */}
      {hareketDuzenle && (
        <ModalKapsayici onKapat={() => setHareketDuzenle(null)} zIndex={300}>
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>Tahsilat Düzenle</div>
              <button onClick={() => setHareketDuzenle(null)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <FormAlan label="Tutar (₺) *">
                <input type="number" value={hareketDuzenle.tutar} onChange={e => setHareketDuzenle({ ...hareketDuzenle, tutar: e.target.value })} autoFocus
                  style={{ ...inputStil, fontSize: '22px', fontWeight: '800', color: '#0D3B7A', border: '2px solid #0D3B7A', padding: '12px' }} />
              </FormAlan>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <FormAlan label="Tarih">
                  <input type="date" value={hareketDuzenle.tarih} onChange={e => setHareketDuzenle({ ...hareketDuzenle, tarih: e.target.value })} style={inputStil} />
                </FormAlan>
                <FormAlan label="Açıklama">
                  <input value={hareketDuzenle.aciklama} onChange={e => setHareketDuzenle({ ...hareketDuzenle, aciklama: e.target.value })} placeholder="Açıklama" style={inputStil} />
                </FormAlan>
              </div>
            </div>
            <BtnPrimary onClick={hareketGuncelle} disabled={kayitYapiliyor}>{kayitYapiliyor ? 'Kaydediliyor...' : 'Güncelle'}</BtnPrimary>
          </div>
        </ModalKapsayici>
      )}
    </div>
  );
}

// ── Küçük yardımcılar ────────────────────────────────────────
const inputStil = {
  width: '100%', padding: '10px', border: '1px solid #E2E8F0',
  borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
};
const selectStil = {
  width: '100%', padding: '10px', border: '1px solid #E2E8F0',
  borderRadius: '8px', fontSize: '14px',
};

function FormAlan({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: '12px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>{label}</div>
      {children}
    </div>
  );
}

function BtnPrimary({ onClick, disabled, children, renk = '#0D3B7A' }) {
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ width: '100%', padding: '14px', background: renk, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.7 : 1 }}>
      {children}
    </button>
  );
}

export default MuhasebeciPanel;
